import { z } from 'zod';
export const referralSchema = z
    .object({
    receivedBy: z.string().min(1, 'Received by is required'),
    referralSource: z.string().min(1, 'Referral source is required'),
    admitSource: z.string().min(1, 'Admit source is required'),
    referralDate: z.string().optional(),
    unknownReferralDate: z.boolean().optional(),
    startOfCareDate: z.string().optional(),
    noStartOfCareDate: z.boolean().optional(),
    specificInstructions: z.string().optional(),
    careType: z.array(z.string()).min(1, 'At least one care type is required'),
    notes: z.string().optional(),
})
    .superRefine((data, ctx) => {
    if (!data.unknownReferralDate && !data.referralDate?.trim()) {
        ctx.addIssue({
            path: ['referralDate'],
            code: z.ZodIssueCode.custom,
            message: 'Referral date is required unless Unknown checked',
        });
    }
    if (!data.noStartOfCareDate && !data.startOfCareDate?.trim()) {
        ctx.addIssue({
            path: ['startOfCareDate'],
            code: z.ZodIssueCode.custom,
            message: "Start of care date is required unless the 'No Start Of Care Date' checkbox is checked",
        });
    }
    if (!data.unknownReferralDate && !data.noStartOfCareDate && data.referralDate && data.startOfCareDate) {
        const referral = new Date(data.referralDate);
        const start = new Date(data.startOfCareDate);
        if (start < referral) {
            ctx.addIssue({
                path: ['startOfCareDate'],
                code: z.ZodIssueCode.custom,
                message: 'Start of care date cannot be before referral date',
            });
        }
    }
});
